<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.5 12">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          d="M7.5,11.44a.56.56,0,0,1-.56.56H.56A.56.56,0,0,1,0,11.44V2.81a.56.56,0,0,1,.56-.56H2.25V9.19A1.31,1.31,0,0,0,3.56,10.5H7.5ZM8.06,3H10.5V9.19a.56.56,0,0,1-.56.56H3.56A.56.56,0,0,1,3,9.19V.56A.56.56,0,0,1,3.56,0H7.5V2.44A.56.56,0,0,0,8.06,3Zm2.44-.89v.14H8.25V0h.14a.65.65,0,0,1,.4.16l1.54,1.55A.6.6,0,0,1,10.5,2.11Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
